import React, { Component } from 'react'
import TitleField from './TitleField'

import styles from './css/styles.module.css'

class TitleCom extends Component {
    constructor(props) {
        super(props);
        
    }
  
   
    render () {
      
        return <TitleField props={this.props}/>
    }
}

export default TitleCom